import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {DigitalSignSimpleClauseModel} from '../../../../../../../digital-sign/models/digital-sign-simple-clause.model';
import {DigitalSignStartedCustomerProcess} from '@shared/components/core-sign/models/digital-signer.model';
import {DigitalSignEventsService} from '@shared/components/core-sign/services/digital-sign-events.service';
import {DigitalSignClause, DigitalSignClauses} from '../../../../../../../digital-sign/models/digital-sign-clauses';
import {SignersType} from '@shared/components/core-sign/models/enums.model';
import {Subscription} from 'rxjs';
import { TranslateContext } from '@shared/pipes/translate.pipe';

@Component({
	selector: 'amd-digital-sign-customer-procedure-start',
	templateUrl: './digital-sign-customer-procedure-start.component.html',
	styleUrls: ['./digital-sign-customer-procedure-start.component.scss']
})
export class DigitalSignCustomerProcedureStartComponent implements OnInit, OnChanges, OnDestroy {

	@Input() dsStartedProcess: DigitalSignStartedCustomerProcess;
	@Input() customerToken: string;

	modeFixed: string = DigitalSignSimpleClauseModel.MODE_FIXED; //ci dice se un clausola è obligatoria.
	titleClause: string = 'A0';
	contentDialogResponseSubscription: Subscription;
	isAllChecked: boolean = false;
	translateContext = TranslateContext;

	constructor(
		private digitalSignEventsService: DigitalSignEventsService
	) {
	}

	ngOnInit(): void {
		this.contentDialogResponseSubscription =
			this.digitalSignEventsService.contentDialogResponseObservable.subscribe(
				response => {
					this.dsStartedProcess.simpleClauses[response.index] = response.simpleClauses[0];
					this.isAllChecked = this.isAllCheckedMethod();
				}
			);
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (!!changes.customerToken) {
			this.customerToken = changes.customerToken.currentValue;
		}
		if (!!changes.dsStartedProcess) {
			this.dsStartedProcess = changes.dsStartedProcess.currentValue;
		}
	}

	ngOnDestroy(): void {
		if (!!this.contentDialogResponseSubscription) {
			this.contentDialogResponseSubscription.unsubscribe();
		}
	}

	checkBoxChange(event: any): void {
		if (event.checked) {
			this.isAllChecked = this.isAllCheckedMethod();
		} else {
			this.isAllChecked = false;
		}
	}

	isAllCheckedMethod(): boolean {
		for (let i: number = 0; i < this.dsStartedProcess.simpleClauses.length; i++) {
			if (this.dsStartedProcess.simpleClauses[i].values.includes(false)) {
				if (this.dsStartedProcess.simpleClauses[i].mode !== this.modeFixed) {
					return false;
				}
				this.dsStartedProcess.simpleClauses[i].values.fill(true);
			}
		}
		return true;
	}

	openContentElement(index: number, y: number, dialogTitle: string, url: string): void {
		this.digitalSignEventsService.openContentElementDialogSubject.next(
			{
				actionsAlignment: 'center',
				dialogTitle: dialogTitle,
				url: url,
				simpleClauses: [this.dsStartedProcess.simpleClauses[index]],
				index: index,
				token: this.customerToken,
				y: y,
				signer_type: SignersType.CUSTOMER
			}
		);
	}

	clickNext(): void {
		this.digitalSignEventsService.nextStepCustomerSubject.next({value: true, body: this.getAcceptedClauses()});
	}

	private getAcceptedClauses(): any {
		const result: DigitalSignClauses = new DigitalSignClauses();
		for (let i: number = 0; i < this.dsStartedProcess.simpleClauses.length; i++) {
			const simpleClause: DigitalSignSimpleClauseModel = this.dsStartedProcess.simpleClauses[i];
			result.clauses.push(new DigitalSignClause(simpleClause.id, !simpleClause.values.includes(false)));
		}
		return result;
	}

	abortProcedure(): void {
		this.digitalSignEventsService.abortCustomerProcedureSubject.next();
	}
}
